export const koreaCountry = {
  name: "Korea",
  localized_name: "한국",
  iso_code: "KR",
  country_code: "010",
  sms_available: true,
};
